import { SEARCH_MAX_LIMIT } from '@/constants/search';

export const clampSearchLimit = (limit) => Math.min(limit, SEARCH_MAX_LIMIT);
